import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hospitality-bot-loader-bounce',
  templateUrl: './loader-bounce.component.html',
  styleUrls: ['./loader-bounce.component.scss']
})
export class LoaderBounceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
